<template>
  <v-app>
    <c-snackbar></c-snackbar>
    <c-cabecalho v-if="$route.name != 'Login'"></c-cabecalho>
    <router-view :key="$route.fullPath"></router-view>
    <div>
    <c-rodape></c-rodape>
    </div>
  </v-app>
</template>

<script>
import Cabecalho from "./components/geral/Cabecalho";
import Rodape from "./components/geral/Rodape";
import SnackBar from "./components/geral/SnackBar.vue";

export default {
  name: "App",
  components: {
    "c-cabecalho": Cabecalho,
    "c-rodape": Rodape,
    "c-snackbar": SnackBar
  }
};
</script>
